<template>
  <tooltip
    :content="tooltipContent()"
    class="d-flex justify-content-center align-items-center text-center"
    :class="avatarClass"
    :style="randombg ? randomBgColor : ''"
  >
    <span class="initials text-white align-self-center"
      >{{ $filters.first(firstname) }}{{ $filters.first(lastname) }}</span
    >
  </tooltip>
</template>

<script>
import Tooltip from '@/components/Tooltip.vue'

import { stringToHslColor } from '../utilities/helpers.js'

export default {
  components: {
    Tooltip
  },
  props: {
    tooltip: {
      required: false,
      default: false
    },
    shape: {
      required: false,
      default: 'circle'
    },
    firstname: {
      required: true,
      validator: prop => typeof prop === 'string' || prop === null
    },
    lastname: {
      required: true,
      validator: prop => typeof prop === 'string' || prop === null
    },
    background: {
      type: String,
      default: 'bg-primary'
    },
    randombg: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    randomBgColor() {
      return `background-color: ${stringToHslColor(`${this.firstname} ${this.lastname}`, 30, 50)}`
    },
    avatarClass() {
      let className = this.shape === 'circle' ? 'rounded-circle' : 'rounded'
      if (!this.randombg) {
        className += ` ${this.background}`
      }
      return className
    }
  },
  methods: {
    tooltipContent() {
      if (this.tooltip) {
        return `${this.firstname} ${this.lastname}`
      }
      return null
    }
  }
}
</script>

<style scoped>
.initials {
  position: relative;
  font-size: 50px; /* 50% of parent */
  line-height: 50px; /* 50% of parent */
}

body[data-leftbar-theme='dark'] {
  .rounded-circle,
  .rounded-square {
    background-color: var(--secondary) !important;
    color: var(--gray-200) !important;
  }
}

/* avatar-circle: width/height = $size, .initials font-size/line-height = $size * 0.5 */
.avatar-circle {
  width: 100px;
  height: 100px;

  .initials {
    position: relative;
    font-size: 50px;
    line-height: 50px;
  }
}

.avatar-circle-sm {
  width: 32px;
  height: 32px;

  .initials {
    position: relative;
    font-size: 16px;
    line-height: 16px;
  }
}

.avatar-circle-lg {
  width: 250px;
  height: 250px;

  .initials {
    position: relative;
    font-size: 125px;
    line-height: 125px;
  }
}

/* avatar-square: width/height = $size, border-radius = $size * 0.2, .initials font-size/line-height = $size * 0.4 */
.avatar-square {
  width: 100px;
  height: 100px;
  border-radius: 20px !important;

  .initials {
    position: relative;
    font-size: 40px;
    line-height: 40px;
  }
}

.avatar-square-sm {
  width: 40px;
  height: 40px;
  border-radius: 8px !important;

  .initials {
    position: relative;
    font-size: 16px;
    line-height: 16px;
  }
}

.avatar-square-lg {
  width: 250px;
  height: 250px;
  border-radius: 50px !important;

  .initials {
    position: relative;
    font-size: 100px;
    line-height: 100px;
  }
}

.farmer-detail {
  .initials {
    font-size: 48px;
    font-weight: 600;
  }
}
</style>
